import React from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useLocation } from 'react-router-dom'
import { auth } from '../Auth/firebase.init';
import { allowedEmails } from '../Blog/AllBlog';

const Sidebar = ({ setActive, active }) => {
    const pathname = useLocation().pathname;
    const [user] = useAuthState(auth);
    return (
        <div className='w-[250px] hidden lg:block  h-full rounded px-2 py-5'>

            <Link
                to={'/dashboard'}
                onClick={() => setActive("profile")}
                className={`btn text-white  ${pathname === "/dashboard" ? "btn-primary" : "btn-neutral"} w-full`}>
                Dashboard
            </Link>
            {
                allowedEmails.includes(user?.email) && <>
                    <Link
                        to={'/dashboard/blogs'}
                        onClick={() => setActive("blogs")}
                        className={`btn text-white  ${pathname.includes("blogs") ? "btn-primary" : "btn-neutral"} w-full mt-2`}>
                        All Blogs
                    </Link>
                    <Link
                        to={'/dashboard/write'}
                        onClick={() => setActive("write")}
                        className={`btn text-white  ${pathname.includes("write") ? "btn-primary" : "btn-neutral"} w-full mt-2`}>
                        Write a Blog
                    </Link>
                </>
            }

            <Link
                to={'/dashboard/feedback'}
                onClick={() => setActive("Feedback")}
                className={`btn text-white  mt-2 ${pathname.includes("feedback") ? "btn-primary" : "btn-neutral"} w-full`}>
                Write a Feedback
            </Link>
        </div>
    )
}

export default Sidebar